<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="健康首页id,外键{zb_health_home.id}" prop="healthHomeId" >
        <a-input v-model="form.healthHomeId" placeholder="请输入健康首页id,外键{zb_health_home.id}" />
      </a-form-model-item>
      <a-form-model-item label="状态 " prop="type" >
      </a-form-model-item>
      <a-form-model-item label="睡眠图数据" prop="picture" >
        <a-input v-model="form.picture" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="开始时间" prop="sleepMax" >
        <a-date-picker style="width: 100%" v-model="form.sleepMax" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="时间 单位(分钟)" prop="sleep" >
        <a-input v-model="form.sleep" placeholder="请输入时间 单位(分钟)" />
      </a-form-model-item>
      <a-form-model-item label="结束时间" prop="sleepMin" >
        <a-date-picker style="width: 100%" v-model="form.sleepMin" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="睡眠分析" prop="analyse" >
        <a-input v-model="form.analyse" placeholder="请输入睡眠分析" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSleep, addSleep, updateSleep } from '@/api/heart/sleep'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        healthHomeId: null,

        type: null,

        picture: null,

        sleepMax: null,

        sleep: null,

        sleepMin: null,

        analyse: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        healthHomeId: [
          { required: true, message: '健康首页id,外键{zb_health_home.id}不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '状态 不能为空', trigger: 'change' }
        ],
        sleepMax: [
          { required: true, message: '开始时间不能为空', trigger: 'blur' }
        ],
        sleep: [
          { required: true, message: '时间 单位(分钟)不能为空', trigger: 'blur' }
        ],
        sleepMin: [
          { required: true, message: '结束时间不能为空', trigger: 'blur' }
        ],
        analyse: [
          { required: true, message: '睡眠分析不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        healthHomeId: null,
        type: null,
        picture: null,
        sleepMax: null,
        sleep: null,
        sleepMin: null,
        analyse: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSleep({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSleep(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSleep(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
